// extracted by mini-css-extract-plugin
export default {"flexNegativa":"LogFlex_flexNegativa__fxzoP","flexNegativaOverflow":"LogFlex_flexNegativaOverflow__IpU8o","flexPositiva":"LogFlex_flexPositiva__UkJsr"};